import { createContext, Dispatch, SetStateAction, useContext, useState } from 'react'

type CutOffHoverContextType = {
  isCutOffHover: boolean
  setIsCutOffHover: Dispatch<SetStateAction<boolean>>
}

const CutOffHoverContext = createContext<CutOffHoverContextType | null>(null)

export const useCutOffHoverContext = (): CutOffHoverContextType => {
  const context = useContext(CutOffHoverContext)

  if (!context) {
    throw new Error('useCutOffHoverContext must be used within a CutOffHoverProvider')
  }

  return context
}

export const CutOffHoverProvider = ({ children }: { children: React.ReactNode }) => {
  const [isCutOffHover, setIsCutOffHover] = useState(false)

  return <CutOffHoverContext.Provider value={{ isCutOffHover, setIsCutOffHover }}>{children}</CutOffHoverContext.Provider>
}

export const CutOffHoverConsumer = ({ children }: { children: (context: CutOffHoverContextType) => React.ReactNode }) => {
  return (
    <CutOffHoverContext.Consumer>
      {(context) => {
        if (!context) {
          throw new Error('CutOffHoverConsumer must be used within a CutOffHoverProvider')
        }

        return children(context)
      }}
    </CutOffHoverContext.Consumer>
  )
}
